// extracted by mini-css-extract-plugin
export default {"timerList":"Timer_timerList__t2K4v","timeNumber":"Timer_timeNumber__FJixz","timeUnit":"Timer_timeUnit__goJkr"};